// src/components/DeleteModal.jsx
import { useState } from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { ref, listAll, deleteObject } from "firebase/storage";
import { db, storage } from "../firebase";

export default function DeleteModal({ post, onClose, onSuccess }) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const folderRef = ref(storage, `posts/${post.slug}`);
      const listed = await listAll(folderRef);
      await Promise.all(listed.items.map((item) => deleteObject(item)));
      await deleteDoc(doc(db, "posts", post.id));
      onSuccess();
    } catch (err) {
      console.error(err);
      setError("삭제 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={styles.modal}>
        <div style={styles.iconWrap}>
          <div style={styles.icon}>⚠️</div>
        </div>
        <div style={styles.title}>게시물을 삭제하시겠습니까?</div>
        <div style={styles.desc}>
          <span style={styles.postName}>{post.title}</span>
          <br />
          첨부된 PDF 파일 {post.files?.length || 0}개가 영구 삭제됩니다.
          <br />이 작업은 되돌릴 수 없습니다.
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.actions}>
          {/* 취소 버튼: 붉은색 */}
          <button
            style={{ ...styles.btn, ...styles.cancelBtn }}
            onClick={onClose}
            disabled={deleting}
          >
            취소
          </button>
          {/* 삭제 버튼: 더 진한 붉은색 */}
          <button
            style={{ ...styles.btn, ...styles.deleteBtn, opacity: deleting ? 0.7 : 1 }}
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting ? "삭제 중..." : "삭제"}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1100,
    backdropFilter: "blur(4px)",
  },
  modal: {
    background: "#fffbeb",
    border: "1px solid #fde68a",
    borderRadius: "12px",
    padding: "32px 28px",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
    boxShadow: "0 30px 80px rgba(0,0,0,0.15)",
  },
  iconWrap: { marginBottom: "16px" },
  icon: { fontSize: "40px" },
  title: {
    color: "#111827",
    fontSize: "17px",
    fontWeight: "700",
    marginBottom: "12px",
  },
  desc: {
    color: "#6b7280",
    fontSize: "13px",
    lineHeight: "1.7",
    marginBottom: "24px",
  },
  postName: {
    color: "#0369a1",
    fontFamily: "monospace",
    fontSize: "12px",
    wordBreak: "break-all",
  },
  error: {
    background: "rgba(239,68,68,0.08)",
    border: "1px solid rgba(239,68,68,0.4)",
    borderRadius: "6px",
    color: "#dc2626",
    fontSize: "13px",
    padding: "10px 14px",
    marginBottom: "16px",
  },
  actions: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
  },
  btn: {
    padding: "10px 28px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    border: "none",
    fontFamily: "inherit",
    transition: "opacity 0.2s",
  },
  /* 취소 버튼: 붉은색 계열 (연한) */
  cancelBtn: {
    background: "#fee2e2",
    color: "#dc2626",
    border: "1px solid #fca5a5",
  },
  /* 삭제 버튼: 짙은 붉은색 */
  deleteBtn: {
    background: "linear-gradient(135deg, #ef4444, #b91c1c)",
    color: "#fff",
  },
};
